import React from 'react';
import RestInputItem from 'components/RestInput/RestInputItem';
import RestEditor from 'components/RestInput/RestEditor';

const NichesForm = (props) => (
  <div {...props}>
    <RestInputItem source="name" header="niches.name" />
    <RestEditor source="description" header="niches.description" />
  </div>
);

NichesForm.propTypes = {};

export default NichesForm;
